import { useEffect, useState } from "react";
import TopSection from "./topSection";
import PersonalInfoCard from "./personalInfoCard";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import StoreSection from "./storeSection";
import { useSnackbar } from "../SnackbarContext";
import axiosInstance from "../../configuration/request";
import DeliverySection from "./deliverySection";
import CustomButton from "../elements/CustomButton/CustomButton";
import TydiiLoader from "../../tydiiLoader";

export default function Profile() {
  
  const showSnackbar = useSnackbar();
  const { loginDetails } = useSelector((state) => state.counter);
  const userId = loginDetails.userId || null;
  const [personalDetails, setPersonalDetails] = useState({});
  const [storeDetails, setStoreDetails] = useState({});
  const [deliveryDetails, setDeliveryDetails] = useState({});
  const [accountId, setAccountId] = useState(null);
  const [accountStatus, setAccountStatus] = useState(false);

  const [isLoading, setIsLoading] = useState(false);



  useEffect(() => {
    fetchUser();
  }, []);

  const fetchUser = () => {
    axiosInstance
      .get(`/customer/users?id=${userId}`)
      .then((res) => {
        let accountID = null
        let data = res?.data?.data[0];
        let address = res?.data?.data[0]?.addresses[0];
        const formattedUser = {
          fullName: data?.name || "",
          email: data?.email || "",
          mobile: data?.phone_number || "",
          birthDate: dayjs(data?.dob) || null,
          gender: data?.gender || "",
          addressLine1: address?.house_no,
          addressLine2: address?.street_address,
          landmark: address?.landmark,
          city: address?.city,
          state: address?.state,
          zip: address?.zipcode,
          addressId: address?.id,
          latitude: address?.latlongs[0]?.latitude,
          longitude: address?.latlongs[0]?.longitude,
          latlngID: address?.latlongs[0]?.id,
          profileImage: data?.profile_img_url || "",
          userType: data?.userType
        };
        let deliveryData = null;
        if (data?.deliveryPerson) {
          deliveryData = {
            vehicle_number: data.deliveryPerson.vehicle_number || "",
            vehicle_type: data.deliveryPerson.vehicle_type || "",
            uploadDoc: data.deliveryPerson.uploadDoc || [],
          };
        }
        setDeliveryDetails(deliveryData)
        setStoreDetails(data?.stores[0]);
        setPersonalDetails(formattedUser);
        if (data?.stores && data?.stores.length > 0) {
          accountID = data?.stores[0]?.stripeAccountId
        } else {
          accountID = data?.deliveryPerson?.stripeAccountId
        }
        setAccountId(accountID)
        if (accountID) {
          fetchAccountStatus(accountID)
        }

      })
      .catch((error) => {
        if (error?.response?.data?.message) {
          showSnackbar(error?.response?.data?.message, "error");
        } else {
          showSnackbar("Something went wrong!", "error");
        }

      });
  };


  const fetchAccountStatus = (accountID) => {
    axiosInstance
      .get(`/payment/stripe/status/${accountID}`)
      .then((res) => {
        setAccountStatus(res?.data?.status)
      })
      .catch((error) => {
        showSnackbar(error?.response?.data?.message || "Something went wrong!", "error");
      });
  };

  const handleSave = (payload) => {
    axiosInstance
      .patch(`/customer/users/${userId}`, payload)
      .then((res) => {
        showSnackbar("Your details updated successfully");
        fetchUser();
      })
      .catch((error) => {
        if (error?.response?.data?.message) {
          showSnackbar(error?.response?.data?.message, "error");
        } else {
          showSnackbar("Something went wrong!", "error");
        }

      });
  };

  const handleStripSetup = () => {
    let payload = {
      email: personalDetails.email,
      type: loginDetails?.userType === 'business user' ? "store" : 'delivery',
      businessName:loginDetails?.userType === 'business user' ? storeDetails.storeName : '',
      country: "US"
    }
    axiosInstance
      .post(`/payment/stripe/create-account`, payload)
      .then((res) => {
        setIsLoading(true)
        window.location.href = res?.data?.data?.onboardingUrl;
      })
      .catch((error) => {
        showSnackbar(error?.response?.data?.message || "Something went wrong!", "error");
      });
  };

  const completeStripSetup = () => {

    axiosInstance
      .get(`/payment/stripe/refresh/${accountId}`)
      .then((res) => {
        setIsLoading(true)
        window.location.href = res?.data?.data?.onboardingUrl;
      })
      .catch((error) => {
        showSnackbar(error?.response?.data?.message || "Something went wrong!", "error");
      });
  };

  return (
    <div className="max-w-6xl mx-auto p-6 space-y-6 bg-white rounded-xl shadow border">
      {isLoading && <TydiiLoader />}
      {/* Profile header */}
      <div className=" rounded-xl  border p-5">

        <TopSection personalDetails={personalDetails}
          onSave={(payload) => handleSave(payload)} />
      </div>

{loginDetails?.userType !== "employee user" && (<div className="rounded-xl border p-5">
  {accountId ? (
    <div className="w-full flex flex-col lgs:flex-row justify-between items-start lgs:items-center">

      <div className="text-sm text-gray-700 flex items-center gap-3">
        <span className="font-[600]">Stripe Account ID : </span>
        {accountId}

        {/* ✅ SHOW TICK BADGE WHEN ACCOUNT SETUP COMPLETED */}
        {accountStatus && (
          <span className="flex items-center gap-1 bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-semibold shadow-sm border border-green-300">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.5 12.75l6 6 9-13.5"
              />
            </svg>
            Setup Completed
          </span>
        )}
      </div>

      {/* SHOW BUTTON ONLY IF SETUP NOT COMPLETED */}
      {!accountStatus && (
        <div className="mt-4 lgs:mt-0">
          <CustomButton
            onClick={completeStripSetup}
            customeClass="gradient-button w-[200px] h-[35px]"
          >
            Complete account setup
          </CustomButton>
        </div>
      )}

    </div>
  ) : (
    <div className="w-full flex justify-end items-center">
      <CustomButton
        onClick={handleStripSetup}
        customeClass="gradient-button w-[200px] h-[35px]"
      >
        Setup stripe account
      </CustomButton>
    </div>
  )}
</div>)}

      <div className=" rounded-xl  border p-5">
        <PersonalInfoCard
          personalDetails={personalDetails}
          onSave={(payload) => handleSave(payload)}
        />
      </div>
      {storeDetails && loginDetails.userType === "business user" && (
        <div className="rounded-xl  border p-5">
          <StoreSection
            storeDetails={storeDetails}
            onSave={(payload) => handleSave(payload)}
          />
        </div>
      )}
      {deliveryDetails && (personalDetails.userType === "delivery user" || personalDetails.userType === "employee user") && (
        <div className="rounded-xl  border p-5">
          <DeliverySection
            deliveryDetails={deliveryDetails}
            onSave={(payload) => handleSave(payload)}
          />
        </div>
      )}
    </div>
  );
}
